module.exports = __webpack_public_path__ + "static/media/Brazil-Flag.4af4b0d6.png";